<template>
  <fieldset class="fieldset">
    <legend class="legend" :class="requiredClass">
      <slot name="legend"></slot>
    </legend>
    <div class="select-wrap">
      <select :id="idName" v-bind:class="[{ 'error-field': !!errors }, 'select']" :name="inputName"
              :value="selected" @change="onSelectChange">
        <option value="">選択してください</option>
        <option v-for="item in items" :key="item[valueProp]" :value="item[valueProp]">{{ item[labelProp] }}</option>
      </select>
    </div>
    <div v-if="!!errors" class ="form-error">
      <li v-for="(error, index) in errors" :key="index" class="form-error-item">
        {{ error }}
      </li>
    </div>
  </fieldset>
</template>

<script>

export default {
  name: 'SelectionField',

  props: {
    // Vue 3 v-model prop
    modelValue: {
      default: ''
    },

    inputName: {
      type: String,
      required: true
    },

    items: {
      type: Array,
      default: () => []
    },

    // 表示名のプロパティ
    labelProp: {
      type: String,
      default: 'label'
    },

    // 値のプロパティ
    valueProp: {
      type: String,
      default: 'value'
    },

    // 必須項目か
    required: {
      type: Boolean,
      required: true
    },

    idName: {
      type: String
    },

    errors: {
      type: Array,
      required: false
    }
  },
  emits: ['update:modelValue', 'change'],

  data: function () {
    return {
      selected: this.modelValue || '' // select のデフォルトが '' なのを考慮
    }
  },

  computed: {
    requiredClass: function () {
      const className = this.required ? 'required' : 'elective'

      const result = {}
      result[className] = true

      return result
    }
  },

  methods: {
    onSelectChange (event) {
      this.selected = event.target.value
      this.$emit('update:modelValue', this.selected)
      this.$emit('change', this.selected)
    }
  }
}
</script>
